import React from 'react';

export const ContractWiserLogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 32, height: 32, textSize: "text-lg" },
    default: { width: 40, height: 40, textSize: "text-xl" },
    large: { width: 56, height: 56, textSize: "text-2xl" },
    xlarge: { width: 80, height: 80, textSize: "text-3xl" }
  };

  const { width, height, textSize } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 48 48" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Document base */}
        <path 
          d="M12 6C12 4.89543 12.8954 4 14 4H28L36 12V42C36 43.1046 35.1046 44 34 44H14C12.8954 44 12 43.1046 12 42V6Z" 
          fill="#2E4033"
        />
        {/* Document fold */}
        <path 
          d="M28 4L36 12H30C28.8954 12 28 11.1046 28 10V4Z" 
          fill="#547A64"
        />
        {/* Shield/Check mark circle */}
        <circle 
          cx="32" 
          cy="32" 
          r="12" 
          fill="#C06E52"
        />
        {/* Checkmark */}
        <path 
          d="M27 32L30 35L37 28" 
          stroke="white" 
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        {/* Document lines */}
        <path 
          d="M17 20H27" 
          stroke="#9EB8A8" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        <path 
          d="M17 26H24" 
          stroke="#9EB8A8" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        <path 
          d="M17 32H21" 
          stroke="#9EB8A8" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
      </svg>
      <span className={`font-heading font-semibold text-eucalypt-800 ${textSize}`}>
        ContractWiser
      </span>
    </div>
  );
};

export const ContractWiserLogoIcon = ({ className = "", size = 40 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 48 48" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Document base */}
      <path 
        d="M12 6C12 4.89543 12.8954 4 14 4H28L36 12V42C36 43.1046 35.1046 44 34 44H14C12.8954 44 12 43.1046 12 42V6Z" 
        fill="#2E4033"
      />
      {/* Document fold */}
      <path 
        d="M28 4L36 12H30C28.8954 12 28 11.1046 28 10V4Z" 
        fill="#547A64"
      />
      {/* Shield/Check mark circle */}
      <circle 
        cx="32" 
        cy="32" 
        r="12" 
        fill="#C06E52"
      />
      {/* Checkmark */}
      <path 
        d="M27 32L30 35L37 28" 
        stroke="white" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      {/* Document lines */}
      <path 
        d="M17 20H27" 
        stroke="#9EB8A8" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M17 26H24" 
        stroke="#9EB8A8" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M17 32H21" 
        stroke="#9EB8A8" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ContractWiserLogo;
